import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API, auth, PageHead } from './finance/shared';
import { EmptyState } from '../../components/dashboard/TodaySchedule';
import Icon from '../../components/dashboard/DashboardIcons';

const fmtDT = (d) => (d ? new Intl.DateTimeFormat('ar-SA-u-ca-gregory', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(d)) : '—');

export default function ActivityLogPage() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    (async () => {
      try { const res = await axios.get(`${API}/activity-log`, auth()); setActivities(Array.isArray(res.data) ? res.data : []); }
      catch { setActivities([]); }
      setLoading(false);
    })();
  }, []);

  const filtered = activities.filter((a) => {
    const q = search.trim();
    return !q || a.action?.includes(q) || a.details?.includes(q) || a.user_name?.includes(q);
  });

  return (
    <div className="mx-auto max-w-5xl space-y-4" data-testid="activity-log-page">
      <PageHead title="سجل النشاط" desc="آخر 50 عملية تمت داخل المنشأة" />
      <div className="rounded-xl border border-slate-200 bg-white">
        <div className="flex items-center gap-2 border-b border-slate-100 px-4 py-3">
          <div className="flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-1.5">
            <Icon name="search" className="w-4 h-4 text-slate-400" />
            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="بحث في السجل..." className="w-48 bg-transparent text-sm outline-none" data-testid="activity-search" />
          </div>
          <span className="mr-auto text-xs text-slate-400">{filtered.length} نشاط</span>
        </div>
        {loading ? <div className="space-y-2 p-4">{[1, 2, 3, 4].map((i) => <div key={i} className="h-12 animate-pulse rounded-lg bg-slate-100" />)}</div>
          : filtered.length === 0 ? <div className="p-6"><EmptyState icon="clock" text="لا يوجد نشاط مسجل" testId="activity-empty" /></div>
          : (
            <div className="divide-y divide-slate-50">
              {filtered.map((a, i) => (
                <div key={`${a.created_at || ''}-${i}`} className="flex items-start gap-3 px-4 py-3" data-testid="activity-row">
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#16233b]/10 text-[#16233b]"><Icon name="clock" className="w-4 h-4" /></span>
                  <div className="min-w-0 flex-1">
                    <div className="text-sm font-bold text-slate-800">{a.action}</div>
                    {a.details && <div className="text-sm text-slate-500">{a.details}</div>}
                    <div className="mt-0.5 text-xs text-slate-400">{a.user_name || '—'} · {fmtDT(a.created_at)}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
      </div>
    </div>
  );
}
